var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8238 0.350702C12.0657 0.123273 12.3877 -0.00245916 12.7217 3.64524e-05C13.0557 0.00253207 13.3757 0.133061 13.6141 0.364078C13.8525 0.595096 13.9907 0.908535 13.9995 1.23825C14.0084 1.56797 13.8871 1.88819 13.6614 2.13132L6.809 10.5935C6.69117 10.7188 6.54895 10.8194 6.39086 10.8892C6.23277 10.959 6.06205 10.9966 5.8889 10.9998C5.71575 11.0029 5.54373 10.9716 5.38313 10.9076C5.22253 10.8436 5.07665 10.7483 4.9542 10.6274L0.409958 6.14026C0.283408 6.02382 0.181906 5.8834 0.111507 5.72739C0.0411069 5.57137 0.00325191 5.40296 0.000200455 5.23218C-0.002851 5.06141 0.0289637 4.89177 0.0937458 4.7334C0.158528 4.57503 0.254951 4.43117 0.377262 4.31039C0.499573 4.18962 0.645267 4.09441 0.805652 4.03044C0.966036 3.96647 1.13783 3.93506 1.31077 3.93807C1.48372 3.94108 1.65428 3.97846 1.81228 4.04798C1.97028 4.11749 2.11248 4.21772 2.2304 4.34268L5.82664 7.89205L11.7912 0.388011C11.8019 0.374954 11.8117 0.362498 11.8238 0.350702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.0604077744aa0cc140bc16259576b2a7.svg";
export { ForwardRef as ReactComponent };